import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../utils/date';
import { TrainerLink } from '../../../shared/links/ProfileLink';

const CommonSpecialRow = ({
    raceDatetime,
    specialText,
    trainerFrom,
    trainerTo,
}) => (
    <tr
        className="ui-table__row hp-formTable__special"
        key={raceDatetime}
    >
        <td className="ui-table__cell hp-formTable__special__date">
            {formatDate(raceDatetime, 'DDMMMYY')}
        </td>
        <td
            className="ui-table__cell"
            colSpan={10}
        >
            { specialText || (
                <span>
                    Changed Trainer notification: <TrainerLink {...trainerFrom} />
                    {' '}to <TrainerLink {...trainerTo} />
                </span>
            )}
        </td>
    </tr>
);

const trainerProp = {
    trainerStyleName: PropTypes.string.isRequired,
    trainerUid: PropTypes.number.isRequired,
};

CommonSpecialRow.propTypes = {
    raceDatetime: PropTypes.string,
    specialText: PropTypes.string,
    trainerFrom: PropTypes.shape(trainerProp),
    trainerTo: PropTypes.shape(trainerProp),
};

export default CommonSpecialRow;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/CommonSpecialRow.jsx